<div class="header">
  <img src="../../../../../public/assets/images/hospital-building.svg" alt="" />
  <p class="title-card">{{ textPointer + '.visit' | translate }}</p>
</div>
<div class="text-card">
  <p>{{ textPointer + '.findStructure' | translate }}</p>
</div>
<div class="buttons">
  @if (textPointer === 'MNM') {
    <ds-button
      class="first-btn"
      text="{{ textPointer + '.cardPrint' | translate }}"
      [iconRight]="'/public/assets/images/barcode.svg'"
      [width]="'small'"
      [styleType]="'empty-main'"
      (click)="generateDigitalCardLink()"
    >
    </ds-button>
  }
  <ds-button
    (click)="openDossier()"
    class="second-btn"
    text="{{ textPointer + '.find' | translate }}"
    [iconRight]="textPointer === 'MNM' ? '/public/assets/images/search.svg' : ''"
    [width]="'small'"
  ></ds-button>
</div>
